/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: getters.ts
 * Class: getters.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { GetterTree } from 'vuex';
import { CreatePaymentResponse, PaymentState, PaymentStates } from './types';
import { MutationRequestStatus, RootState } from '../types';

export const getters: GetterTree<PaymentState, RootState> = {
  createPaymentLoading:
    (state): boolean => state.createPayment.status === MutationRequestStatus.LOADING,
  createPaymentSuccess:
    (state): boolean => state.createPayment.status === MutationRequestStatus.SUCCESS,
  createPaymentError:
    (state): boolean => state.createPayment.status === MutationRequestStatus.ERROR,

  getPayment: (state) => state.getPayment.data,
  getPaymentLoading: (state) => state.getPayment.status === MutationRequestStatus.LOADING,
  getPaymentLoaded: (state) => state.getPayment.status === MutationRequestStatus.SUCCESS,
  getPaymentError: (state) => state.getPayment.status === MutationRequestStatus.ERROR,

  addPaymentResponse: (state): CreatePaymentResponse => state.createPayment.data,
  addPaymentErrorMessage: (state): string => state.createPayment.error.message,

  additionalPaymentDetailsLoading:
    (state): boolean => state.additionalPaymentDetails.status === MutationRequestStatus.LOADING,
  additionalPaymentDetailsError: (state): boolean => {
    if (state.additionalPaymentDetails.status === MutationRequestStatus.ERROR) {
      return true;
    }

    if (state.additionalPaymentDetails.data) {
      const validStates = [PaymentStates.SUCCESS, PaymentStates.PENDING];
      return !validStates.includes(state.additionalPaymentDetails.data.resultCode);
    }

    return false;
  },
  additionalPaymentDetailsSuccess:
    (state): boolean => state.additionalPaymentDetails.status === MutationRequestStatus.SUCCESS
            && state.additionalPaymentDetails.data.resultCode === PaymentStates.SUCCESS,
  additionalPaymentDetailsPending:
    (state): boolean => state.additionalPaymentDetails.status === MutationRequestStatus.SUCCESS
            && state.additionalPaymentDetails.data.resultCode === PaymentStates.PENDING,

  paymentState: (state): MutationRequestStatus => state.additionalPaymentDetails.status,
  paymentSuccess: (state): boolean => state.additionalPaymentDetails.data
        && state.additionalPaymentDetails.data.resultCode === PaymentStates.SUCCESS,
  paymentPending: (state): boolean => state.additionalPaymentDetails.data
        && state.additionalPaymentDetails.data.resultCode === PaymentStates.PENDING,
  paymentError:
    (state): boolean => state.additionalPaymentDetails.status === MutationRequestStatus.ERROR,

  disableMethodLoading: (state) => state.disableMethod.status === MutationRequestStatus.LOADING,
  disableMethodError: (state) => state.disableMethod.status === MutationRequestStatus.ERROR,
  disableMethodSuccess: (state) => state.disableMethod.status === MutationRequestStatus.SUCCESS,
};
